import { useInstrumentLogger as useBaseInstrumerLogger, } from '@bingads-webui-campaign-react/common-hooks';
import { useCallback } from 'react';

const decorateMessage = (scenarioName, message) => `[LinkedInCampaigns][${scenarioName}] ${message}`;

export const useInstrumentLogger = ({ scenarioName, activityName }) => {
  const { trace, error } = useBaseInstrumerLogger({ scenarioName, activityName });

  const decoratedTrace = useCallback(message => trace(decorateMessage(scenarioName, message)), [trace, scenarioName]);
  const decoratedError = useCallback(message => error(decorateMessage(scenarioName, message)), [error, scenarioName]);

  return {
    trace: decoratedTrace,
    error: decoratedError,
  };
};
